module.exports = __webpack_public_path__ + "static/media/APOTHEO_LABO_ORLIMAN.f2bd845d.png";